import React from "react";
import { useNavigate } from "react-router-dom";

export default function ModerationDemoPage() {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(35px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes pulse {
          0%,100% { transform: scale(1); box-shadow: 0 0 25px rgba(0,242,255,.30); }
          50% { transform: scale(1.06); box-shadow: 0 0 70px rgba(0,242,255,.85); }
        }

        @keyframes staffOnline {
          0%,100% { opacity: .45; transform: scale(.9); }
          50% { opacity: 1; transform: scale(1.15); }
        }

        @keyframes alertMove {
          0% { transform: translateX(-25px); opacity: 0; }
          35% { opacity: 1; }
          100% { transform: translateX(25px); opacity: 0; }
        }

        @keyframes scan {
          0% { transform: translateX(-140%); opacity: 0; }
          40% { opacity: 1; }
          100% { transform: translateX(140%); opacity: 0; }
        }
      `}</style>

      <button onClick={() => navigate(-1)} style={styles.back}>
        ← Retour
      </button>

      <div style={styles.wrapper}>
        <div style={styles.iconCircle}>
          <span style={styles.onlineDot}></span>
          <div style={styles.icon}>🛡️</div>
        </div>

        <h1 style={styles.title}>Modération active</h1>

        <p style={styles.subtitle}>
          Signalement et contrôle des contenus en temps réel, avec une équipe connectée
          pour répondre aux besoins des utilisateurs.
        </p>

        <div style={styles.demoBox}>
          <div style={styles.scanLine}></div>

          <div style={styles.alertCard}>🚩 Signalement reçu</div>
          <div style={styles.alertCardTwo}>👥 Équipe staff connectée</div>
          <div style={styles.alertCardThree}>✅ Réponse et action adaptées</div>
        </div>

        <div style={styles.cards}>
          <div style={styles.card}>
            <div style={styles.cardIcon}>🚩</div>
            <h3 style={styles.cardTitle}>Signalement</h3>
            <p style={styles.cardText}>Les utilisateurs peuvent alerter rapidement en cas de problème.</p>
          </div>

          <div style={styles.card}>
            <div style={styles.cardIcon}>👥</div>
            <h3 style={styles.cardTitle}>Staff connecté</h3>
            <p style={styles.cardText}>Une équipe de staff peut suivre, analyser et répondre aux besoins.</p>
          </div>

          <div style={styles.card}>
            <div style={styles.cardIcon}>⚡</div>
            <h3 style={styles.cardTitle}>Action rapide</h3>
            <p style={styles.cardText}>Les contenus problématiques peuvent être contrôlés en temps réel.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background:
      "radial-gradient(circle at top right, rgba(0,242,255,0.22), transparent 34%), radial-gradient(circle at bottom left, rgba(0,145,255,0.18), transparent 32%), #03070d",
    color: "#fff",
    fontFamily: "Arial, sans-serif",
    padding: "32px 18px",
    overflowY: "auto",
    textAlign: "center",
  },

  back: {
    position: "fixed",
    top: 22,
    left: 22,
    zIndex: 20,
    padding: "11px 18px",
    borderRadius: 16,
    border: "1px solid rgba(0,242,255,0.45)",
    background: "rgba(0,12,20,0.9)",
    color: "#00f2ff",
    fontWeight: 900,
    cursor: "pointer",
    boxShadow: "0 0 18px rgba(0,242,255,0.25)",
  },

  wrapper: {
    maxWidth: 980,
    margin: "0 auto",
    paddingTop: 70,
    animation: "fadeUp 0.8s ease forwards",
  },

  iconCircle: {
    width: 135,
    height: 135,
    margin: "0 auto 28px",
    borderRadius: "50%",
    border: "2px solid rgba(0,242,255,0.7)",
    background: "rgba(0,242,255,0.08)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    animation: "pulse 2.4s infinite",
  },

  onlineDot: {
    position: "absolute",
    top: 18,
    right: 20,
    width: 18,
    height: 18,
    borderRadius: "50%",
    background: "#00ff88",
    boxShadow: "0 0 18px rgba(0,255,136,0.9)",
    animation: "staffOnline 1.4s infinite",
  },

  icon: {
    fontSize: 58,
  },

  title: {
    margin: "0 0 14px",
    fontSize: "clamp(38px, 5vw, 62px)",
    color: "#fff",
    fontWeight: 900,
    textShadow: "0 0 24px rgba(0,242,255,0.8)",
  },

  subtitle: {
    maxWidth: 850,
    margin: "0 auto 34px",
    color: "#9befff",
    fontSize: 21,
    lineHeight: 1.6,
  },

  demoBox: {
    maxWidth: 760,
    margin: "0 auto 28px",
    padding: 24,
    borderRadius: 28,
    background: "rgba(0,12,20,0.82)",
    border: "1px solid rgba(0,242,255,0.35)",
    boxShadow: "0 0 35px rgba(0,242,255,0.16)",
    position: "relative",
    overflow: "hidden",
  },

  scanLine: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(110deg, transparent 20%, rgba(0,242,255,0.14) 50%, transparent 75%)",
    animation: "scan 3s infinite",
  },

  alertCard: {
    position: "relative",
    zIndex: 2,
    padding: "14px 18px",
    marginBottom: 12,
    borderRadius: 16,
    background: "rgba(255,60,90,0.12)",
    color: "#ffd5dc",
    fontWeight: 900,
    animation: "alertMove 4s infinite",
  },

  alertCardTwo: {
    position: "relative",
    zIndex: 2,
    padding: "14px 18px",
    marginBottom: 12,
    borderRadius: 16,
    background: "rgba(0,242,255,0.10)",
    color: "#00f2ff",
    fontWeight: 900,
    animation: "alertMove 4s infinite 0.8s",
  },

  alertCardThree: {
    position: "relative",
    zIndex: 2,
    padding: "14px 18px",
    borderRadius: 16,
    background: "rgba(0,255,136,0.10)",
    color: "#8dffcb",
    fontWeight: 900,
    animation: "alertMove 4s infinite 1.6s",
  },

  cards: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 16,
  },

  card: {
    padding: 24,
    borderRadius: 24,
    background: "rgba(0,12,20,0.82)",
    border: "1px solid rgba(0,242,255,0.25)",
    boxShadow: "0 0 24px rgba(0,242,255,0.10)",
  },

  cardIcon: {
    fontSize: 34,
    marginBottom: 12,
  },

  cardTitle: {
    margin: "0 0 10px",
    color: "#fff",
    fontSize: 20,
    fontWeight: 900,
  },

  cardText: {
    margin: 0,
    color: "#9befff",
    fontSize: 15,
    lineHeight: 1.5,
  },
};
